import PropTypes from "prop-types";
import {
  inputTypePropType,
  valuePropType,
  labelPropType,
  onChangePropType,
  disabledPropType,
  requiredPropType,
  validationPropType,
  messagePropType,
  iconPropType,
  placeholderPropType,
  classNamePropType,
  onFocusPropType,
  onClickPropType,
} from "../../common";

/**
 * PropTypes for Input component
 *
 * @property {('text'|'password'|'email'|'number'|'date'|'time'|'tel'|'url'|'search')} [type] - Input type
 * @property {string} [placeholder] - Placeholder text
 * @property {string|number} [value] - Controlled input value
 * @property {string} [label] - Label text displayed above input
 * @property {function} [onChange] - Change handler callback - receives new value
 * @property {boolean} [disabled] - Disable input interaction
 * @property {boolean} [shouldFocus] - Auto-focus input when true
 * @property {function} [onFocus] - Focus event handler
 * @property {function} [onClick] - Click event handler
 * @property {number} [min] - Minimum value for numeric inputs
 * @property {number} [max] - Maximum value for numeric inputs
 * @property {number} [maxLength] - Maximum character length
 * @property {boolean} [required] - Show asterisk on label
 * @property {boolean|string} [valid] - Validation state (true/false/"true"/"false" or undefined)
 * @property {string} [message] - Validation message displayed based on valid state
 * @property {string} [className] - Additional CSS classes
 * @property {boolean} [useBorder] - Show input border (false for borderless mode)
 * @property {React.ReactNode} [iconBefore] - Icon element to display before input
 * @property {React.ReactNode} [iconAfter] - Icon element to display after input
 * @property {boolean} [clickableIcon] - If true, clicking icon clears input
 * @property {string} [iconClassName] - Additional CSS classes for icon container
 */
export const inputPropTypes = {
  type: inputTypePropType,
  placeholder: placeholderPropType,
  value: valuePropType,
  label: labelPropType,
  onChange: onChangePropType,
  disabled: disabledPropType,
  shouldFocus: PropTypes.bool,
  onFocus: onFocusPropType,
  onClick: onClickPropType,
  min: PropTypes.number,
  max: PropTypes.number,
  maxLength: PropTypes.number,
  required: requiredPropType,
  valid: validationPropType,
  message: messagePropType,
  className: classNamePropType,
  useBorder: PropTypes.bool,
  iconBefore: iconPropType,
  iconAfter: iconPropType,
  clickableIcon: PropTypes.bool,
  iconClassName: classNamePropType,
};
